"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var youtube_player_1 = __importDefault(require("youtube-player"));
var player_1 = __importDefault(require("@vimeo/player"));
var collapse = function () {
    var collapseNodes = document.querySelectorAll('.js-collapse');
    var videoArray = [];
    var ytArray = [];
    var vimeoArray = [];
    collapseNodes.forEach(function (collapseNode) {
        var videoContainers = collapseNode.querySelectorAll('.c-video.-classic');
        var ytContainers = collapseNode.querySelectorAll('.c-video.-yt');
        var vimeoContainers = collapseNode.querySelectorAll('.c-video.-vimeo');
        videoContainers.forEach(function (container) {
            var player = container.querySelector('video');
            videoArray.push(player);
        });
        ytContainers.forEach(function (container) {
            var src = container.dataset.yt;
            var wrapper = container.querySelector('.c-video_wrapper div');
            var player;
            if (wrapper && src) {
                player = (0, youtube_player_1.default)(wrapper, {
                    videoId: src,
                });
            }
            ytArray.push(player);
        });
        vimeoContainers.forEach(function (container) {
            var videoWrapper = container.querySelector('.c-video_wrapper');
            var videoId = Number(container.dataset.video);
            var player;
            if (videoId && videoWrapper) {
                player = new player_1.default(videoWrapper, {
                    id: videoId,
                    controls: true,
                    autopause: false,
                    autoplay: false,
                    muted: false,
                    loop: false,
                    quality: 'auto',
                });
                vimeoArray.push(player);
            }
        });
    });
    var hide = function (target) {
        var parentNode = target.closest('.js-collapse');
        var collapseEl = parentNode.querySelector('[data-target]');
        parentNode.classList.remove('-active');
        if (collapseEl) {
            collapseEl.style.height = "".concat(0, "px");
            collapseEl.classList.remove('-active');
            videoArray.forEach(function (player) {
                player.pause();
            });
            ytArray.forEach(function (player) {
                player.pauseVideo();
            });
            vimeoArray.forEach(function (player) {
                player.pause();
            });
        }
    };
    var show = function (target) {
        var parentNode = target.closest('.js-collapse');
        var collapseEl = parentNode.querySelector('[data-target]');
        parentNode.classList.add('-active');
        if (collapseEl) {
            collapseEl.style.height = "".concat(collapseEl.scrollHeight, "px");
            collapseEl.classList.add('-active');
        }
    };
    var handleClick = function (event) {
        event.preventDefault();
        var target = event.target;
        var parentNode = target.closest('.js-collapse');
        var header = document.querySelector('.l-header');
        if (parentNode.classList.contains('-active')) {
            hide(target);
        }
        else {
            show(target);
        }
        collapseNodes.forEach(function (collapseNode) {
            if (collapseNode !== parentNode) {
                hide(collapseNode);
            }
        });
        var scrollOffset = header ? (header === null || header === void 0 ? void 0 : header.scrollHeight) + 10 : 0;
        setTimeout(function () {
            var y = parentNode.getBoundingClientRect().top + window.scrollY - scrollOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }, 350);
    };
    var setCollapseHeight = function (target) {
        setTimeout(function () {
            var targetHeight = target.scrollHeight;
            if (targetHeight === 0) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                setCollapseHeight(target);
            }
            else {
                target.style.height = "".concat(targetHeight, "px");
            }
        }, 10);
    };
    // .js-collapse[]
    collapseNodes.forEach(function (element) {
        var trigger = element.querySelector('.js-collapse-trigger, .c-collapse_header');
        trigger === null || trigger === void 0 ? void 0 : trigger.addEventListener('click', function (event) { return handleClick(event); });
    });
    window.addEventListener('resize', function () {
        collapseNodes.forEach(function (element) {
            var id = element.id.trim();
            var targetElement = element.querySelector("[data-target=\"".concat(id, "\"]"));
            var isDesktopDisabled = element.dataset.collapseDisable === 'desktop' && window.innerWidth > 992;
            if (!targetElement || isDesktopDisabled)
                return;
            if (element.classList.contains('-active')) {
                show(targetElement);
                targetElement.removeAttribute('style');
                setCollapseHeight(targetElement);
            }
            else {
                hide(targetElement);
            }
        });
    });
    var eventResize = document.createEvent('Event');
    eventResize.initEvent('resize', false, true);
    window.dispatchEvent(eventResize);
};
collapse();
